import React from 'react'

const DeleteConfirm = ({items, data, confirmFunction, closeConfirm, formatDate, titleText}) => {

  return (
    <>
    <div className=''>
      <div className="left-1/2 flex h-100 flex-1 w-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto">
          <h2 className="text-center text-xl font-bold leading-9 tracking-tight text-gray-900">
            {titleText ? titleText : "Are you confirm to delete the record ?"}
          </h2>
          {titleText ? "" :
          <p className='text-l'> {items[0].title} : { items[0].type === 'date' ? ` ${formatDate(data[items[0].name])}` : data[items[0].name]}  </p>}
        </div>
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">      
          <div className='flex space-x-5'>
              <button
                onClick={()=>confirmFunction(titleText ? null : data.uuid)}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-800"
              >
                {titleText ? "Yes" : "Delete"}
              </button>
              <button
                onClick={closeConfirm}
                className="flex w-full justify-center rounded-md bg-gray-400 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Cancel
              </button>
            </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default DeleteConfirm

  